import { connect } from 'react-redux';
import AddSemiForCorrection from './AddSemiForCorrection';
import { inputReadyProducts, updateReadyProducts, addInputPiece } from '../../../store/actions/inputReadyProducts';
import { getReadyProducts, deleteReadyProducts } from '../../../store/actions/correctionReadyProducts';
import {
  clearCorrectionSemiProductsClear,
  getSemiProductByReady,
  getCorrectionSemi
} from '../../../store/actions/correctionSemiProducts';

const mapStateToProps = ({
  correctionReadyProductsReducer,
  userReducer,
  tabsReducer,
  inputReadyProductReducer,
  correctionSemiProductsReducer
}) => ({
  correctionReadyProductsReducer,
  userReducer,
  tabsReducer,
  inputReadyProductReducer,
  correctionSemiProductsReducer
});
const mapDispatchToProps = {
  inputReadyProducts,
  updateReadyProducts,
  getReadyProducts,
  getSemiProductByReady,
  deleteReadyProducts,
  clearCorrectionSemiProductsClear,
  getCorrectionSemi,
  addInputPiece
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddSemiForCorrection);
